import { render, staticRenderFns } from "./DummyPage.vue?vue&type=template&id=82fb73b6&"
import script from "./DummyPage.vue?vue&type=script&lang=js&"
export * from "./DummyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports